import { FormInput } from 'components/shared/Forms/ReduxForm'
import config from 'config/config'
import placeholder from 'images/placeholder_inverted.png'
import { I18n } from 'lib/i18n'
import React from 'react'
import DropZone from 'react-dropzone'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field, formValues, reduxForm } from 'redux-form'
import { replaceMedium, saveMedium } from 'redux/media'
import { Button, Grid, Icon, Image, Modal, Table } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  const { uploadingMedia, media } = state.media
  return { uploadingMedia, media }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      saveMedium,
      replaceMedium,
    },
    dispatch
  )
}

class EditModal extends React.Component {
  render() {
    const { uploadingMedia, media, saveMedium, replaceMedium } = this.props //redux
    const { id } = this.props //formValues
    const { handleSubmit, initialized, destroy } = this.props //reduxForm
    const currentMedium = media.find((medium) => formValues && medium.id === id)

    return (
      <Modal open={initialized} size="small" className="inverted editModal">
        <Modal.Header content={I18n.t('admin.mediaBrowser.edit_modal')} />
        <Modal.Content>
          <Modal.Description>
            <Grid stackable>
              <Grid.Row>
                <Grid.Column width={4}>
                  <Table basic="very" compact verticalAlign="top">
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell>
                          <DropZone
                            onDrop={(accepted) => {
                              replaceMedium(id, accepted[0])
                            }}
                            style={{}}
                            activeClassName="valid"
                            className="dropZone">
                            {currentMedium &&
                            currentMedium.content_type === 'application/pdf' ? (
                              <Icon name="file pdf outline" size="large" />
                            ) : (
                              <Image
                                fluid
                                src={
                                  currentMedium && currentMedium.small
                                    ? config.api_url + currentMedium.small
                                    : placeholder
                                }
                              />
                            )}
                            <Button
                              attached="bottom"
                              fluid
                              secondary
                              size="tiny"
                              loading={uploadingMedia}
                              icon={uploadingMedia ? 'spinner' : 'cloud upload'}
                              content={
                                uploadingMedia
                                  ? ''
                                  : I18n.t('admin.mediaBrowser.replace')
                              }
                              disabled={uploadingMedia}
                              onClick={(e) => e.preventDefault()}
                            />
                          </DropZone>
                        </Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                </Grid.Column>
                <Grid.Column width={8}>
                  <Table basic="very" compact verticalAlign="top">
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell colSpan="2">
                          <Field
                            component={FormInput}
                            fluid
                            name="title_de"
                            width={12}
                            icon="flag"
                            placeholder={I18n.t('navigation.languages.de')}
                          />
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell colSpan="2">
                          <Field
                            component={FormInput}
                            fluid
                            name="title_fr"
                            width={12}
                            icon="flag outline"
                            placeholder={I18n.t('navigation.languages.fr')}
                          />
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell
                          collapsing
                          className="unobtrusive"
                          content={I18n.t('admin.mediaBrowser.file_name')}
                        />
                        <Table.Cell>
                          {currentMedium && currentMedium.file_name}
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell
                          collapsing
                          className="unobtrusive"
                          content={I18n.t('admin.mediaBrowser.file_size')}
                        />
                        <Table.Cell>
                          {currentMedium && currentMedium.file_size}
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell
                          collapsing
                          className="unobtrusive"
                          content={I18n.t('admin.mediaBrowser.content_type')}
                        />
                        <Table.Cell
                          content={currentMedium && currentMedium.content_type}
                        />
                      </Table.Row>
                    </Table.Body>
                  </Table>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={() => destroy()}
            content={I18n.t('global.cancel')}
            color="black"
          />
          <Button
            onClick={handleSubmit((formValues) => {
              saveMedium(formValues)
              destroy()
            })}
            content={I18n.t('global.save')}
            positive
            icon="checkmark"
            labelPosition="right"
          />
        </Modal.Actions>
      </Modal>
    )
  }
}

EditModal = connect(mapStateToProps, mapDispatchToProps)(EditModal)
EditModal = formValues('id')(EditModal)
EditModal = reduxForm({ form: 'mediaBrowserEdit' })(EditModal)
export default EditModal



// WEBPACK FOOTER //
// ./src/components/shared/MediaBrowser/EditModal.jsx